<script lang="ts">
	import { setContext } from "svelte";
	import { run } from "svelte/legacy";

	import { toStore, writable, type Writable } from "svelte/store";
	import type { User } from "#gen/identities/v1/identities_pb.js";
	import { onNavigate } from "$app/navigation";
	import { page } from "$app/state";
	import type { LayoutData } from "./$types";
	import type { Snippet } from "svelte";

	interface Props {
		data: LayoutData;
		children?: Snippet;
	}

	let { data, children }: Props = $props();

	const user: Writable<User | undefined> = writable(data.user);
	const isDesktop: Writable<boolean | undefined> = writable(data.isDesktop);
	const preventScroll: Writable<boolean> = writable(false);
	const desktopViewEnabled = toStore(() => (page.data as { suite?: { desktopViewEnabled?: boolean } }).suite?.desktopViewEnabled ?? false);

	run(() => {
		user.set(data.user);
	});
	run(() => {
		isDesktop.set(data.isDesktop);
	});
	run(() => {
		user.set(data.user);
	});

	setContext("user", user);
	setContext("navigation", data.navigation);
	setContext("isDesktop", isDesktop);
	setContext("desktopViewEnabled", desktopViewEnabled);
	setContext("preventScroll", preventScroll);

	// Crossfade flow-to-flow navigations instead of the default teardown-flash.
	// The interstitial is excluded so advanced-geo destinations don't crossfade into a geo prompt.
	function isFlowRoute(id: string | null): boolean {
		return !!id && (id.startsWith("/(consumer)/s/") || id.startsWith("/(consumer)/v/")) && !id.includes("/interstitial");
	}

	onNavigate(navigation => {
		if (navigation.shallow && navigation.type === "goto") return;
		if (typeof document === "undefined" || !document.startViewTransition) return;
		if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
		if (!isFlowRoute(navigation.from?.route?.id ?? null) || !isFlowRoute(navigation.to?.route?.id ?? null)) return;
		return new Promise<void>(resolve => {
			const transition = document.startViewTransition(async () => {
				resolve();
				try {
					await navigation.complete;
				} catch {
					// on aborted/failed navigation
				}
			});
			transition.finished.catch(() => {});
		});
	});
</script>

{@render children?.()}
